import styled, { css } from 'styled-components';
import { Box } from '@bechtel/gds';

export const headerColumnWidth = '321px';
export const columnWidth = '180px'; //TODO: Has to be 120px based on zeplin, BE needs to provided name as per Zeplin.

export const MatrixContainerStyled = styled(Box).attrs({
  flexDirection: { sm: 'column' },
})`
  background-color: ${({ theme }) => theme.colors.white};
  overflow-y: auto;
  height: 100vh;
`;

export const TableStyled = styled.table`
  ${({ theme }) => css`
    width: 100%;
    border-right: solid 1px ${theme.colors.grey[300]};
  `}
`;

export const TableRowHeaderStyled = styled.tr`
  ${({ theme }) => css`
    background-color: ${theme.colors.grey[200]};
  `}
`;

export const TableHeaderStickyStyled = styled.th`
  position: sticky;
  top: 0;
  left: 0;
  vertical-align: top;
`;

export const HeaderContainerStlyed = styled(Box)`
  ${({ theme }) => css`
    background-color: ${theme.colors.grey[200]};
    padding-top: calc(${theme.spacings[500]} + ${theme.spacings[100]});
    padding-bottom: calc(${theme.spacings[500]} + ${theme.spacings[100]});
  `}
`;

export const HeaderStyled = styled(Box).attrs({
  alignItems: { sm: 'center' },
  justifyContent: { sm: 'center' },
  ml: { sm: '500' },
})`
  ${({ theme }) => css`
    background-color: ${theme.colors.grey[200]};
    font-size: ${theme.fontSizes[300]};
    font-family: ${theme.fontFamilies['graphik']};
    color: ${theme.colors.grey[1000]};
    font-weight: ${theme.fontWeights[600]};
    white-space: nowrap;
  `}
`;
